/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePathwayTemplateDto } from '../../models/response-pathway-template-dto';

export interface PathwayTemplatesControllerFindOne$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Pathway template type
 */
  type: string;
}

export function pathwayTemplatesControllerFindOne(http: HttpClient, rootUrl: string, params: PathwayTemplatesControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePathwayTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, pathwayTemplatesControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePathwayTemplateDto>;
    })
  );
}

pathwayTemplatesControllerFindOne.PATH = '/thalea-pathways/pathway-templates/{tenant}/{type}';
